import { LocalStorageService } from '../services/local-storage.service';

export const statesToPersist = [
  'backend',
  'session',
  'settings',
  'side-menu',
  'badge',
  'dayInfoPage',
  'customer-items',
  'expenses-catalogue-items',
  'expenses-items',
  'material-catalogue-items',
  'material-items',
  'note-items',
  'quantity-items',
  'presence-list-items',
  'cost-center-items',
  'operation-items',
  'order-items',
  'personal-list',
];

export const persistStateConfig = {
  include: statesToPersist,
  storage: new LocalStorageService(),
  preStorageUpdate(storeName, state) {
    if (storeName.indexOf('items') >= 0 || storeName === 'personal-list') {
      return {
        filterOptions: state?.filterOptions,
        columns: state?.columns,
      };
    }

    if (storeName === 'dayInfoPage') {
      return {
        tableColumns: state?.tableColumns,
        selectedDateRange: state?.selectedDateRange,
      };
    }
    if (storeName === 'badge') {
      return {
        settings: state?.settings,
      };
    }
    if (storeName === 'side-menu') {
      return {
        settings: state?.settings,
      };
    }
    return state;
  },
};
